module.exports = __webpack_public_path__ + "img/vipon-logo-black.8468b07a.svg";